// Layout
Vue.component('sidebar', require('./layout/Sidebar.vue').default);

// Dashboard
Vue.component('users-count', require('./dashboard/UsersCount.vue').default);
Vue.component('roles-count', require('./dashboard/RolesCount.vue').default);
Vue.component('configuration-count', require('./dashboard/ConfigurationCount.vue').default);

// Profile
Vue.component('profile', require('./profile/Profile.vue').default);
Vue.component('profile-password', require('./profile/Password.vue').default);

// Users
Vue.component('users-index', require('./users/Index.vue').default);
Vue.component('users-create', require('./users/Create.vue').default);
Vue.component('users-edit', require('./users/Edit.vue').default);

// Roles
Vue.component('roles-index', require('./roles/Index.vue').default);
Vue.component('roles-create', require('./roles/Create.vue').default);
Vue.component('roles-edit', require('./roles/Edit.vue').default);

// Drawer
Vue.component('drawer', require('./drawer/Drawer.vue').default);
Vue.component('document-drawer', require('./drawer/DocumentDrawer.vue').default);
Vue.component('configuration-list', require('./drawer/List.vue').default);
Vue.component('configuration-request', require('./drawer/Request.vue').default);
